import { render } from "./AgileView.vue?vue&type=template&id=479f0a1c&scoped=true"
import script from "./AgileView.vue?vue&type=script&lang=js"
export * from "./AgileView.vue?vue&type=script&lang=js"

import "./AgileView.vue?vue&type=style&index=0&id=479f0a1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479f0a1c"]])

export default __exports__